import React, { ReactNode, KeyboardEvent } from 'react'
import { TextFieldProps } from '@material-ui/core/TextField'
import { InputAdornment } from '@material-ui/core'
import { StyledTextField, StyledError, StyledDone } from './styled'

export interface ICustomTextFieldOrigin {
  endAdornment?: ReactNode
  defaultValueAdornment?: ReactNode
  touched?: boolean
  min?: number
  max?: number
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
}

export const CustomTextFieldOrigin = ({
  endAdornment,
  defaultValueAdornment,
  min,
  max,
  ...props
}: TextFieldProps & ICustomTextFieldOrigin) => (
    <StyledTextField
      fullWidth
      InputLabelProps={{ shrink: true }}
      FormHelperTextProps={{
        className: 'textfield-helptext',
      }}
      InputProps={{
        inputProps: { min, max },
        endAdornment: endAdornment
          ? endAdornment
          : (
            <InputAdornment position="end" className="input-adornment">
              {defaultValueAdornment}
              {!props.disabled &&
                (props.touched || props.value) && (
                  props.error ? <StyledError /> : <StyledDone color="primary" />
                )}
            </InputAdornment>
          ),
      }}
      {...props}
    />
  )
